<template>
  <el-dialog
    :visible.sync="
      modal.open
    "
    :close-on-click-modal="false"
    :z-index="2002"
    :width="
      '40rem'
    ">
    <div
      slot="title"
      class="
        dialog-title
      ">
      <b>
        {{ modal.title }}
      </b>
    </div>
    <div class="page-content">
      <section
        class="
          input-action
        ">
        <div class="input">
          <input
            v-model="
              filter.text
            "
            type="text"
            class="
              el-input__inner
            "
            :placeholder="
              'ชื่อโครงการ'
            "
            @keyup.enter="
              () => search(filter.text, 1)
            "
          />
        </div>
        <div class="action">
          <el-button
            icon="
              el-icon-search
            "
            @click="
              () => search(filter.text, 1)
            ">
            ค้นหา
          </el-button>
        </div>
      </section>

      <section v-if="loader">
        <p>
          <b class="unknown">
            กำลังค้นหา...
          </b>
        </p>
      </section>

      <section
        v-if="
          items.length == 0
        "
        class="empty">
        <img
          src="@/assets/images/admin/empty.png"
        />
        <p>
          <b class="unknown">
            ไม่พบข้อมูล
          </b>
        </p>
      </section>

      <section
        v-if="
          !loader && items.length > 0
        "
        class="content vertical">
        <div
          v-for="
            item in items
          "
          :key="item.projectId"
          class="item">
          <div class="heading">
            <div class="icon">
              <img
                :src="
                  item.projectIcon
                "
                @error="
                  (event) => imgError(event)
                "
              />
            </div>
            <div class="content">
              <div class="name">
                <p class="code">
                  {{ item.projectCode }}
                </p>
                <p
                  class="
                    subtitle ellipsis
                  ">
                  {{ item.projectName }}
                </p>
              </div>
              <p class="pin">
                <span v-if="item.amphurName">
                  <i class="el-icon-location" /> {{ item.amphurName }}
                </span>
                <span v-else class="unknown">
                  N/A
                </span>
              </p>
            </div>
          </div>
          <el-button
            :plain="
              !isSelected(item)
            "
            type="sc-asset"
            class="
              item-action
            "
            @click="
              () => value = item
            ">
            {{ isSelected(item) ? 'เลือกอยู่' : 'เลือก' }}
          </el-button>
        </div>
      </section>

      <section
        v-if="
          !loader && items.length > 0
        "
        class="footer vertical">
        <el-pagination
          :background="true"
          :layout="
            'prev, pager, next'
          "
          :pager-count="5"
          :current-page="
            paging.page
          "
          :page-size="
            paging.limit
          "
          :total="
            paging.total
          "
          @current-change="
            (page) => search(
              filter.text, page
            )
          "
        />
        <label>
          พบ {{ paging.total }} รายการ
        </label>
      </section>
    </div>
  </el-dialog>
</template>

<script lang="js">

// Client
import { SubscriberReportClient as Client } from '@/clients/BackendAdminClient/subscriber-report'

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loader: false,
      modal: {
        open  : this.open,
        title : 'เลือกโครงการ'
      },
      filter: {
        text: ''
      },
      paging: {
        page  : 1,
        limit : 5,
        total : 0
      },
      items: [],
      value: this.selected,
      searchTimer: null,
      loaderTimer: null
    }
  },
  watch: {
    open(open) {
      this.modal.open = open
    },
    'modal.open': function(open) {

      // Validate Open State
      if (open) {
        this.search(
          this.filter.text, this.paging.page
        )
      }
      
      // Emit Open State
      this.$emit(
        'update:open', open
      )
    },
    selected(item) {
      this.value = item
    },
    value(item) {
      if (item !== this.selected) {
        this.select(item)
      }
    },
    'filter.text': function(text) {

      // Clear timeout
      clearTimeout(this.searchTimer)

      // Delay search
      this.searchTimer = setTimeout(
        () => this.search(text, 1), 200
      )
    }
  },
  beforeDestroy() {

    // Clear Timers
    clearTimeout(this.searchTimer)
    clearTimeout(this.loaderTimer)
  },
  methods: {
    async search(text, page = 1) {

      // Loading
      this.loader = true

      try {

        // Filter Limitation
        const { limit } = this.paging

        // Project List
        const projects = await Client.projects()

        // Search Keyword
        const keyword = text.trim().toLowerCase()

        // Filtered Projects
        const filtered = !keyword ? projects : projects.filter(
          ({ projectName, projectCode }) => (
            projectName.toLowerCase().includes(keyword) ||
            projectCode.toLowerCase().includes(keyword)
          )
        )

        // Paging Offset
        const offset = (page - 1) * limit

        // Set Items
        this.items = filtered.slice(
          offset, offset + limit
        )

        // Set Paging
        Object.assign(
          this.paging, {
            page, total: filtered.length
          }
        )
      }
      catch (error) {

        // Close Modal
        this.modal.open = false

        // Reset Items
        this.items = []

        // Reset Paging
        Object.assign(
          this.paging, { page: 1, total: 0 }
        )

        // Emit Error
        this.$emit(
          'error', error, 'ไม่สามารถโหลดข้อมูลโครงการได้'
        )
      }
      finally {
        clearTimeout(this.loaderTimer)
        this.loaderTimer = setTimeout(
          () => { this.loader = false }, 400
        )
      }
    },
    select(input) {

      // Validate Input
      if (!input) return

      // Select Event
      this.$emit('select', {
        id: Number(input.projectId), name: input.projectName
      })

      // Close Modal
      this.modal.open = false
    },
    imgError(e) {
      e.target.src = 'https://www.scasset.com/images/sca-orange.svg'
    },
    isSelected(item) {
      return Number(item.projectId) === this.selected
    }
  }
}

</script>

<style lang="css" scoped>

.page-content {
  padding     : var(--size-lg);
  padding-top : var(--size-sm);
  gap         : var(--size-sm);
  max-height  : 90svh !important;
}

section.content {
  align-items    : stretch;
  justify-content: flex-start;
  gap            : var(--size-sm);
}

.item {
  align-items : center;
  gap         : var(--size-md);
  padding     : var(--size-sm);
}

.item .heading {
  display     : flex;
  flex        : 1;
  gap         : var(--size-md);
  align-items : center;
  overflow    : hidden;
}

.item .icon {
  flex: none;
}

.item .icon img {
  width         : 3rem;
  aspect-ratio  : 1/1;
  object-fit    : contain;
  border-radius : var(--size-xs);
}

.item .content {
  flex            : 1;
  display         : flex;
  justify-content : space-between;
  align-items     : center;
  gap             : var(--size-sm);
  overflow        : hidden;
}

.item .content .name {
  flex    : 1;
  overflow: hidden;
}

.item .content .pin {
  flex        : none;
  display     : flex;
  align-items : center;
}

.item .code {
  font-weight : bold;
  font-size   : calc(.125rem + var(--size-md));
}

@media screen and (max-width: 480px) {

  .item .content {
    flex-direction : column;
    align-items    : flex-start;
    gap            : var(--size-xs);
  }
}

</style>